/**
 * Filters versions to show only the latest minor per previous major. Used in the vendor accordion
 * to hide review-cycle noise.
 */
export function filterLatestMinorPerMajor<T extends { version: string }>(
  versions: T[],
  currentVersion: string,
): T[] {
  const currentMajor = Number(currentVersion.split(".")[0])
  if (isNaN(currentMajor)) return []

  return versions.filter((v) => {
    const parts = v.version.split(".")
    if (parts.length !== 2 || isNaN(Number(parts[0])) || isNaN(Number(parts[1]))) return false
    const vMajor = Number(parts[0])
    if (vMajor >= currentMajor) return false
    const sameMajor = versions.filter((x) => {
      const xParts = x.version.split(".")
      return xParts.length === 2 && Number(xParts[0]) === vMajor
    })
    if (sameMajor.length === 0) return false
    const maxMinor = Math.max(...sameMajor.map((x) => Number(x.version.split(".")[1])))
    return Number(parts[1]) === maxMinor
  })
}
